import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { AppBar, Button, IconButton, Toolbar, Hidden } from '@mui/material';
import InputIcon from '@mui/icons-material/Input';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';

import logo from '@images/logo.svg';

import { logout } from 'state/actions';
import CONFIG from '@config';

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1,
  },
  logo: {
    height: '50px',
  },

  logoutButton: {
    marginLeft: theme.spacing(1),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
}));

const TopBar = (props) => {
  const { onOpenNavBarMobile, className, ...rest } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="relative">
      <Toolbar>
        <RouterLink to="/">
          <img
            alt="Logo"
            src={CONFIG.LOGIN_HEADER_IMAGE || logo}
            className={classes.logo}
          />
        </RouterLink>
        <div className={classes.flexGrow} />
        <Button
          className={classes.logoutButton}
          color="inherit"
          onClick={handleLogout}>
          <InputIcon className={classes.logoutIcon} />
          {t('sign out')}
        </Button>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onOpenNavBarMobile}>
            <MenuIcon style={{ color: '#fff' }} />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
};

export default TopBar;
